import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { GlobalLoaderService } from './global-loader.service';

@Injectable()
export class GlobalLoaderInterceptor implements HttpInterceptor {

  private activeRequests = 0;

  private readonly SKIP_LOADER_HEADER = 'X-Skip-Loader';
  constructor(private loader: GlobalLoaderService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has(this.SKIP_LOADER_HEADER)) {
      const reqWithoutHeader = req.clone({
        headers: req.headers.delete(this.SKIP_LOADER_HEADER)
      });
      return next.handle(reqWithoutHeader);
    }
    this.activeRequests++;
    this.loader.show();

    return next.handle(req).pipe(
      finalize(() => {
        this.activeRequests--;
        if (this.activeRequests === 0) {
          this.loader.hide();
        }
      })
    );
  }
}
